module.exports = __webpack_public_path__ + "static/banner-265305e2c57684b3dce17746dd1fda08.jpg";